// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/company.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { IconInfo, InfoSection } from "./common";

export const protobufPackage = "api.devplan.types.company";

export interface CompanyDetails {
  id: number;
  name: string;
  logo?: IconInfo | undefined;
  website?: string | undefined;
  infoSections: InfoSection[];
  websiteScanInfo?: WebsiteScanInfo | undefined;
  planning?: CompanyPlanningDetails | undefined;
  orgId?: string | undefined;
  prCommentTrigger?: string | undefined;
  onboardingBackground?: string | undefined;
}

/**
 * Holds company-specific settings. Each of the settings should be updated behind its own API with its own
 * permissions control, unlike CompanyDetails, which are updated as whole now.
 */
export interface CompanySettings {
  companyId: number;
  enableCodeResearch?:
    | boolean
    | undefined;
  /**
   * Company-wide default Roadmap view settings.
   * Used as the baseline initial Roadmap configuration when no per-user override exists.
   */
  roadmapDefault?:
    | RoadmapDefaultView
    | undefined;
  /**
   * Controls whether the workspace uses the full specs-driven experience.
   * Missing/false means Specs are disabled for newly created companies.
   */
  specsEnabled?: boolean | undefined;
}

/**
 * Company-wide default for the Roadmap settings popover.
 * Each field is optional; absent fields fall back to the product baseline.
 */
export interface RoadmapDefaultView {
  /** One of "section" | "status" | "release". */
  viewBy?: string | undefined;
  showDone?: boolean | undefined;
  showArchived?:
    | boolean
    | undefined;
  /** Column ids that are hidden by default. Must match RoadmapColumnId values used by the web client. */
  hiddenColumns: string[];
}

/** Holds per-company, per-view project ordering settings */
export interface ProjectsViewSettings {
  companyId: number;
  viewId: string;
  orderedProjectIds: string[];
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface CompanyPlanningDetails {
  hoursInDay: number;
}

export interface WebsiteScanInfo {
  lastError?: string | undefined;
}

export interface User {
  id: string;
  email: string;
  name: string;
  image: string;
  trialStarted: boolean;
  forceTrial: boolean;
  loopsCustomerCreated: boolean;
  createdAt: Date | undefined;
}

export interface CompanyUser {
  user: User | undefined;
  companyDetails: CompanyUserDetails | undefined;
}

export interface CompanyUserDetails {
  companyId: number;
  userId: string;
  roles: CompanyRole[];
}

export interface CompanyRole {
  role: string;
  createdAt: Date | undefined;
}

export interface UserCompanyInvite {
  id: string;
  email: string;
  companyId: number;
  role: string;
  createdAt: Date | undefined;
  createdBy: string;
}

export interface EnterpriseOrganization {
  id: string;
  name: string;
  logo?: IconInfo | undefined;
  companyIds: number[];
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  plgProvisioned: boolean;
  plgSignupEmailDomain?: string | undefined;
  plgTrialRequiresCard: boolean;
}

export interface OrganizationUserDetails {
  orgId: string;
  userId: string;
  role: string;
}

export interface OrganizationUser {
  user: User | undefined;
  orgDetails: OrganizationUserDetails | undefined;
}

function createBaseCompanyDetails(): CompanyDetails {
  return {
    id: 0,
    name: "",
    logo: undefined,
    website: undefined,
    infoSections: [],
    websiteScanInfo: undefined,
    planning: undefined,
    orgId: undefined,
    prCommentTrigger: undefined,
    onboardingBackground: undefined,
  };
}

export const CompanyDetails: MessageFns<CompanyDetails> = {
  encode(message: CompanyDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.logo !== undefined) {
      IconInfo.encode(message.logo, writer.uint32(26).fork()).join();
    }
    if (message.website !== undefined) {
      writer.uint32(34).string(message.website);
    }
    for (const v of message.infoSections) {
      InfoSection.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.websiteScanInfo !== undefined) {
      WebsiteScanInfo.encode(message.websiteScanInfo, writer.uint32(50).fork()).join();
    }
    if (message.planning !== undefined) {
      CompanyPlanningDetails.encode(message.planning, writer.uint32(58).fork()).join();
    }
    if (message.orgId !== undefined) {
      writer.uint32(66).string(message.orgId);
    }
    if (message.prCommentTrigger !== undefined) {
      writer.uint32(74).string(message.prCommentTrigger);
    }
    if (message.onboardingBackground !== undefined) {
      writer.uint32(82).string(message.onboardingBackground);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.logo = IconInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.website = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.infoSections.push(InfoSection.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.websiteScanInfo = WebsiteScanInfo.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.planning = CompanyPlanningDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.prCommentTrigger = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.onboardingBackground = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyDetails {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      logo: isSet(object.logo) ? IconInfo.fromJSON(object.logo) : undefined,
      website: isSet(object.website) ? globalThis.String(object.website) : undefined,
      infoSections: globalThis.Array.isArray(object?.infoSections)
        ? object.infoSections.map((e: any) => InfoSection.fromJSON(e))
        : globalThis.Array.isArray(object?.info_sections)
        ? object.info_sections.map((e: any) => InfoSection.fromJSON(e))
        : [],
      websiteScanInfo: isSet(object.websiteScanInfo)
        ? WebsiteScanInfo.fromJSON(object.websiteScanInfo)
        : isSet(object.website_scan_info)
        ? WebsiteScanInfo.fromJSON(object.website_scan_info)
        : undefined,
      planning: isSet(object.planning) ? CompanyPlanningDetails.fromJSON(object.planning) : undefined,
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : undefined,
      prCommentTrigger: isSet(object.prCommentTrigger)
        ? globalThis.String(object.prCommentTrigger)
        : isSet(object.pr_comment_trigger)
        ? globalThis.String(object.pr_comment_trigger)
        : undefined,
      onboardingBackground: isSet(object.onboardingBackground)
        ? globalThis.String(object.onboardingBackground)
        : isSet(object.onboarding_background)
        ? globalThis.String(object.onboarding_background)
        : undefined,
    };
  },

  toJSON(message: CompanyDetails): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.logo !== undefined) {
      obj.logo = IconInfo.toJSON(message.logo);
    }
    if (message.website !== undefined) {
      obj.website = message.website;
    }
    if (message.infoSections?.length) {
      obj.infoSections = message.infoSections.map((e) => InfoSection.toJSON(e));
    }
    if (message.websiteScanInfo !== undefined) {
      obj.websiteScanInfo = WebsiteScanInfo.toJSON(message.websiteScanInfo);
    }
    if (message.planning !== undefined) {
      obj.planning = CompanyPlanningDetails.toJSON(message.planning);
    }
    if (message.orgId !== undefined) {
      obj.orgId = message.orgId;
    }
    if (message.prCommentTrigger !== undefined) {
      obj.prCommentTrigger = message.prCommentTrigger;
    }
    if (message.onboardingBackground !== undefined) {
      obj.onboardingBackground = message.onboardingBackground;
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyDetails>): CompanyDetails {
    return CompanyDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyDetails>): CompanyDetails {
    const message = createBaseCompanyDetails();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.logo = (object.logo !== undefined && object.logo !== null) ? IconInfo.fromPartial(object.logo) : undefined;
    message.website = object.website ?? undefined;
    message.infoSections = object.infoSections?.map((e) => InfoSection.fromPartial(e)) || [];
    message.websiteScanInfo = (object.websiteScanInfo !== undefined && object.websiteScanInfo !== null)
      ? WebsiteScanInfo.fromPartial(object.websiteScanInfo)
      : undefined;
    message.planning = (object.planning !== undefined && object.planning !== null)
      ? CompanyPlanningDetails.fromPartial(object.planning)
      : undefined;
    message.orgId = object.orgId ?? undefined;
    message.prCommentTrigger = object.prCommentTrigger ?? undefined;
    message.onboardingBackground = object.onboardingBackground ?? undefined;
    return message;
  },
};

function createBaseCompanySettings(): CompanySettings {
  return { companyId: 0, enableCodeResearch: undefined, roadmapDefault: undefined, specsEnabled: undefined };
}

export const CompanySettings: MessageFns<CompanySettings> = {
  encode(message: CompanySettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.enableCodeResearch !== undefined) {
      writer.uint32(16).bool(message.enableCodeResearch);
    }
    if (message.roadmapDefault !== undefined) {
      RoadmapDefaultView.encode(message.roadmapDefault, writer.uint32(26).fork()).join();
    }
    if (message.specsEnabled !== undefined) {
      writer.uint32(32).bool(message.specsEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanySettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanySettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enableCodeResearch = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roadmapDefault = RoadmapDefaultView.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.specsEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanySettings {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      enableCodeResearch: isSet(object.enableCodeResearch)
        ? globalThis.Boolean(object.enableCodeResearch)
        : isSet(object.enable_code_research)
        ? globalThis.Boolean(object.enable_code_research)
        : undefined,
      roadmapDefault: isSet(object.roadmapDefault)
        ? RoadmapDefaultView.fromJSON(object.roadmapDefault)
        : isSet(object.roadmap_default)
        ? RoadmapDefaultView.fromJSON(object.roadmap_default)
        : undefined,
      specsEnabled: isSet(object.specsEnabled)
        ? globalThis.Boolean(object.specsEnabled)
        : isSet(object.specs_enabled)
        ? globalThis.Boolean(object.specs_enabled)
        : undefined,
    };
  },

  toJSON(message: CompanySettings): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.enableCodeResearch !== undefined) {
      obj.enableCodeResearch = message.enableCodeResearch;
    }
    if (message.roadmapDefault !== undefined) {
      obj.roadmapDefault = RoadmapDefaultView.toJSON(message.roadmapDefault);
    }
    if (message.specsEnabled !== undefined) {
      obj.specsEnabled = message.specsEnabled;
    }
    return obj;
  },

  create(base?: DeepPartial<CompanySettings>): CompanySettings {
    return CompanySettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanySettings>): CompanySettings {
    const message = createBaseCompanySettings();
    message.companyId = object.companyId ?? 0;
    message.enableCodeResearch = object.enableCodeResearch ?? undefined;
    message.roadmapDefault = (object.roadmapDefault !== undefined && object.roadmapDefault !== null)
      ? RoadmapDefaultView.fromPartial(object.roadmapDefault)
      : undefined;
    message.specsEnabled = object.specsEnabled ?? undefined;
    return message;
  },
};

function createBaseRoadmapDefaultView(): RoadmapDefaultView {
  return { viewBy: undefined, showDone: undefined, showArchived: undefined, hiddenColumns: [] };
}

export const RoadmapDefaultView: MessageFns<RoadmapDefaultView> = {
  encode(message: RoadmapDefaultView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.viewBy !== undefined) {
      writer.uint32(10).string(message.viewBy);
    }
    if (message.showDone !== undefined) {
      writer.uint32(16).bool(message.showDone);
    }
    if (message.showArchived !== undefined) {
      writer.uint32(24).bool(message.showArchived);
    }
    for (const v of message.hiddenColumns) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoadmapDefaultView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoadmapDefaultView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.viewBy = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.showDone = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.showArchived = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.hiddenColumns.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoadmapDefaultView {
    return {
      viewBy: isSet(object.viewBy)
        ? globalThis.String(object.viewBy)
        : isSet(object.view_by)
        ? globalThis.String(object.view_by)
        : undefined,
      showDone: isSet(object.showDone)
        ? globalThis.Boolean(object.showDone)
        : isSet(object.show_done)
        ? globalThis.Boolean(object.show_done)
        : undefined,
      showArchived: isSet(object.showArchived)
        ? globalThis.Boolean(object.showArchived)
        : isSet(object.show_archived)
        ? globalThis.Boolean(object.show_archived)
        : undefined,
      hiddenColumns: globalThis.Array.isArray(object?.hiddenColumns)
        ? object.hiddenColumns.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.hidden_columns)
        ? object.hidden_columns.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: RoadmapDefaultView): unknown {
    const obj: any = {};
    if (message.viewBy !== undefined) {
      obj.viewBy = message.viewBy;
    }
    if (message.showDone !== undefined) {
      obj.showDone = message.showDone;
    }
    if (message.showArchived !== undefined) {
      obj.showArchived = message.showArchived;
    }
    if (message.hiddenColumns?.length) {
      obj.hiddenColumns = message.hiddenColumns;
    }
    return obj;
  },

  create(base?: DeepPartial<RoadmapDefaultView>): RoadmapDefaultView {
    return RoadmapDefaultView.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoadmapDefaultView>): RoadmapDefaultView {
    const message = createBaseRoadmapDefaultView();
    message.viewBy = object.viewBy ?? undefined;
    message.showDone = object.showDone ?? undefined;
    message.showArchived = object.showArchived ?? undefined;
    message.hiddenColumns = object.hiddenColumns?.map((e) => e) || [];
    return message;
  },
};

function createBaseProjectsViewSettings(): ProjectsViewSettings {
  return { companyId: 0, viewId: "", orderedProjectIds: [], createdAt: undefined, updatedAt: undefined };
}

export const ProjectsViewSettings: MessageFns<ProjectsViewSettings> = {
  encode(message: ProjectsViewSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.viewId !== "") {
      writer.uint32(18).string(message.viewId);
    }
    for (const v of message.orderedProjectIds) {
      writer.uint32(26).string(v!);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectsViewSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectsViewSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.viewId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orderedProjectIds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectsViewSettings {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      viewId: isSet(object.viewId)
        ? globalThis.String(object.viewId)
        : isSet(object.view_id)
        ? globalThis.String(object.view_id)
        : "",
      orderedProjectIds: globalThis.Array.isArray(object?.orderedProjectIds)
        ? object.orderedProjectIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ordered_project_ids)
        ? object.ordered_project_ids.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: ProjectsViewSettings): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.viewId !== "") {
      obj.viewId = message.viewId;
    }
    if (message.orderedProjectIds?.length) {
      obj.orderedProjectIds = message.orderedProjectIds;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectsViewSettings>): ProjectsViewSettings {
    return ProjectsViewSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectsViewSettings>): ProjectsViewSettings {
    const message = createBaseProjectsViewSettings();
    message.companyId = object.companyId ?? 0;
    message.viewId = object.viewId ?? "";
    message.orderedProjectIds = object.orderedProjectIds?.map((e) => e) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseCompanyPlanningDetails(): CompanyPlanningDetails {
  return { hoursInDay: 0 };
}

export const CompanyPlanningDetails: MessageFns<CompanyPlanningDetails> = {
  encode(message: CompanyPlanningDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hoursInDay !== 0) {
      writer.uint32(8).int32(message.hoursInDay);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyPlanningDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyPlanningDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hoursInDay = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyPlanningDetails {
    return {
      hoursInDay: isSet(object.hoursInDay)
        ? globalThis.Number(object.hoursInDay)
        : isSet(object.hours_in_day)
        ? globalThis.Number(object.hours_in_day)
        : 0,
    };
  },

  toJSON(message: CompanyPlanningDetails): unknown {
    const obj: any = {};
    if (message.hoursInDay !== 0) {
      obj.hoursInDay = Math.round(message.hoursInDay);
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyPlanningDetails>): CompanyPlanningDetails {
    return CompanyPlanningDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyPlanningDetails>): CompanyPlanningDetails {
    const message = createBaseCompanyPlanningDetails();
    message.hoursInDay = object.hoursInDay ?? 0;
    return message;
  },
};

function createBaseWebsiteScanInfo(): WebsiteScanInfo {
  return { lastError: undefined };
}

export const WebsiteScanInfo: MessageFns<WebsiteScanInfo> = {
  encode(message: WebsiteScanInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lastError !== undefined) {
      writer.uint32(10).string(message.lastError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebsiteScanInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebsiteScanInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lastError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebsiteScanInfo {
    return {
      lastError: isSet(object.lastError)
        ? globalThis.String(object.lastError)
        : isSet(object.last_error)
        ? globalThis.String(object.last_error)
        : undefined,
    };
  },

  toJSON(message: WebsiteScanInfo): unknown {
    const obj: any = {};
    if (message.lastError !== undefined) {
      obj.lastError = message.lastError;
    }
    return obj;
  },

  create(base?: DeepPartial<WebsiteScanInfo>): WebsiteScanInfo {
    return WebsiteScanInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WebsiteScanInfo>): WebsiteScanInfo {
    const message = createBaseWebsiteScanInfo();
    message.lastError = object.lastError ?? undefined;
    return message;
  },
};

function createBaseUser(): User {
  return {
    id: "",
    email: "",
    name: "",
    image: "",
    trialStarted: false,
    forceTrial: false,
    loopsCustomerCreated: false,
    createdAt: undefined,
  };
}

export const User: MessageFns<User> = {
  encode(message: User, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.image !== "") {
      writer.uint32(34).string(message.image);
    }
    if (message.trialStarted !== false) {
      writer.uint32(40).bool(message.trialStarted);
    }
    if (message.forceTrial !== false) {
      writer.uint32(48).bool(message.forceTrial);
    }
    if (message.loopsCustomerCreated !== false) {
      writer.uint32(56).bool(message.loopsCustomerCreated);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): User {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.image = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.trialStarted = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.forceTrial = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.loopsCustomerCreated = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): User {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      image: isSet(object.image) ? globalThis.String(object.image) : "",
      trialStarted: isSet(object.trialStarted)
        ? globalThis.Boolean(object.trialStarted)
        : isSet(object.trial_started)
        ? globalThis.Boolean(object.trial_started)
        : false,
      forceTrial: isSet(object.forceTrial)
        ? globalThis.Boolean(object.forceTrial)
        : isSet(object.force_trial)
        ? globalThis.Boolean(object.force_trial)
        : false,
      loopsCustomerCreated: isSet(object.loopsCustomerCreated)
        ? globalThis.Boolean(object.loopsCustomerCreated)
        : isSet(object.loops_customer_created)
        ? globalThis.Boolean(object.loops_customer_created)
        : false,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
    };
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.image !== "") {
      obj.image = message.image;
    }
    if (message.trialStarted !== false) {
      obj.trialStarted = message.trialStarted;
    }
    if (message.forceTrial !== false) {
      obj.forceTrial = message.forceTrial;
    }
    if (message.loopsCustomerCreated !== false) {
      obj.loopsCustomerCreated = message.loopsCustomerCreated;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<User>): User {
    return User.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<User>): User {
    const message = createBaseUser();
    message.id = object.id ?? "";
    message.email = object.email ?? "";
    message.name = object.name ?? "";
    message.image = object.image ?? "";
    message.trialStarted = object.trialStarted ?? false;
    message.forceTrial = object.forceTrial ?? false;
    message.loopsCustomerCreated = object.loopsCustomerCreated ?? false;
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseCompanyUser(): CompanyUser {
  return { user: undefined, companyDetails: undefined };
}

export const CompanyUser: MessageFns<CompanyUser> = {
  encode(message: CompanyUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    if (message.companyDetails !== undefined) {
      CompanyUserDetails.encode(message.companyDetails, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.companyDetails = CompanyUserDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyUser {
    return {
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      companyDetails: isSet(object.companyDetails)
        ? CompanyUserDetails.fromJSON(object.companyDetails)
        : isSet(object.company_details)
        ? CompanyUserDetails.fromJSON(object.company_details)
        : undefined,
    };
  },

  toJSON(message: CompanyUser): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.companyDetails !== undefined) {
      obj.companyDetails = CompanyUserDetails.toJSON(message.companyDetails);
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyUser>): CompanyUser {
    return CompanyUser.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyUser>): CompanyUser {
    const message = createBaseCompanyUser();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.companyDetails = (object.companyDetails !== undefined && object.companyDetails !== null)
      ? CompanyUserDetails.fromPartial(object.companyDetails)
      : undefined;
    return message;
  },
};

function createBaseCompanyUserDetails(): CompanyUserDetails {
  return { companyId: 0, userId: "", roles: [] };
}

export const CompanyUserDetails: MessageFns<CompanyUserDetails> = {
  encode(message: CompanyUserDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    for (const v of message.roles) {
      CompanyRole.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyUserDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyUserDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roles.push(CompanyRole.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyUserDetails {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => CompanyRole.fromJSON(e)) : [],
    };
  },

  toJSON(message: CompanyUserDetails): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => CompanyRole.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyUserDetails>): CompanyUserDetails {
    return CompanyUserDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyUserDetails>): CompanyUserDetails {
    const message = createBaseCompanyUserDetails();
    message.companyId = object.companyId ?? 0;
    message.userId = object.userId ?? "";
    message.roles = object.roles?.map((e) => CompanyRole.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCompanyRole(): CompanyRole {
  return { role: "", createdAt: undefined };
}

export const CompanyRole: MessageFns<CompanyRole> = {
  encode(message: CompanyRole, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== "") {
      writer.uint32(10).string(message.role);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanyRole {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanyRole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanyRole {
    return {
      role: isSet(object.role) ? globalThis.String(object.role) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
    };
  },

  toJSON(message: CompanyRole): unknown {
    const obj: any = {};
    if (message.role !== "") {
      obj.role = message.role;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<CompanyRole>): CompanyRole {
    return CompanyRole.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanyRole>): CompanyRole {
    const message = createBaseCompanyRole();
    message.role = object.role ?? "";
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseUserCompanyInvite(): UserCompanyInvite {
  return { id: "", email: "", companyId: 0, role: "", createdAt: undefined, createdBy: "" };
}

export const UserCompanyInvite: MessageFns<UserCompanyInvite> = {
  encode(message: UserCompanyInvite, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.companyId !== 0) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.role !== "") {
      writer.uint32(34).string(message.role);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserCompanyInvite {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserCompanyInvite();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserCompanyInvite {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
    };
  },

  toJSON(message: UserCompanyInvite): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    return obj;
  },

  create(base?: DeepPartial<UserCompanyInvite>): UserCompanyInvite {
    return UserCompanyInvite.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserCompanyInvite>): UserCompanyInvite {
    const message = createBaseUserCompanyInvite();
    message.id = object.id ?? "";
    message.email = object.email ?? "";
    message.companyId = object.companyId ?? 0;
    message.role = object.role ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    return message;
  },
};

function createBaseEnterpriseOrganization(): EnterpriseOrganization {
  return {
    id: "",
    name: "",
    logo: undefined,
    companyIds: [],
    createdAt: undefined,
    updatedAt: undefined,
    plgProvisioned: false,
    plgSignupEmailDomain: undefined,
    plgTrialRequiresCard: false,
  };
}

export const EnterpriseOrganization: MessageFns<EnterpriseOrganization> = {
  encode(message: EnterpriseOrganization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.logo !== undefined) {
      IconInfo.encode(message.logo, writer.uint32(26).fork()).join();
    }
    writer.uint32(34).fork();
    for (const v of message.companyIds) {
      writer.int32(v);
    }
    writer.join();
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.plgProvisioned !== false) {
      writer.uint32(56).bool(message.plgProvisioned);
    }
    if (message.plgSignupEmailDomain !== undefined) {
      writer.uint32(66).string(message.plgSignupEmailDomain);
    }
    if (message.plgTrialRequiresCard !== false) {
      writer.uint32(72).bool(message.plgTrialRequiresCard);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnterpriseOrganization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnterpriseOrganization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.logo = IconInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.companyIds.push(reader.int32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.companyIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.plgProvisioned = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.plgSignupEmailDomain = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.plgTrialRequiresCard = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnterpriseOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      logo: isSet(object.logo) ? IconInfo.fromJSON(object.logo) : undefined,
      companyIds: globalThis.Array.isArray(object?.companyIds)
        ? object.companyIds.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.company_ids)
        ? object.company_ids.map((e: any) => globalThis.Number(e))
        : [],
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      plgProvisioned: isSet(object.plgProvisioned)
        ? globalThis.Boolean(object.plgProvisioned)
        : isSet(object.plg_provisioned)
        ? globalThis.Boolean(object.plg_provisioned)
        : false,
      plgSignupEmailDomain: isSet(object.plgSignupEmailDomain)
        ? globalThis.String(object.plgSignupEmailDomain)
        : isSet(object.plg_signup_email_domain)
        ? globalThis.String(object.plg_signup_email_domain)
        : undefined,
      plgTrialRequiresCard: isSet(object.plgTrialRequiresCard)
        ? globalThis.Boolean(object.plgTrialRequiresCard)
        : isSet(object.plg_trial_requires_card)
        ? globalThis.Boolean(object.plg_trial_requires_card)
        : false,
    };
  },

  toJSON(message: EnterpriseOrganization): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.logo !== undefined) {
      obj.logo = IconInfo.toJSON(message.logo);
    }
    if (message.companyIds?.length) {
      obj.companyIds = message.companyIds.map((e) => Math.round(e));
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.plgProvisioned !== false) {
      obj.plgProvisioned = message.plgProvisioned;
    }
    if (message.plgSignupEmailDomain !== undefined) {
      obj.plgSignupEmailDomain = message.plgSignupEmailDomain;
    }
    if (message.plgTrialRequiresCard !== false) {
      obj.plgTrialRequiresCard = message.plgTrialRequiresCard;
    }
    return obj;
  },

  create(base?: DeepPartial<EnterpriseOrganization>): EnterpriseOrganization {
    return EnterpriseOrganization.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnterpriseOrganization>): EnterpriseOrganization {
    const message = createBaseEnterpriseOrganization();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.logo = (object.logo !== undefined && object.logo !== null) ? IconInfo.fromPartial(object.logo) : undefined;
    message.companyIds = object.companyIds?.map((e) => e) || [];
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.plgProvisioned = object.plgProvisioned ?? false;
    message.plgSignupEmailDomain = object.plgSignupEmailDomain ?? undefined;
    message.plgTrialRequiresCard = object.plgTrialRequiresCard ?? false;
    return message;
  },
};

function createBaseOrganizationUserDetails(): OrganizationUserDetails {
  return { orgId: "", userId: "", role: "" };
}

export const OrganizationUserDetails: MessageFns<OrganizationUserDetails> = {
  encode(message: OrganizationUserDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.role !== "") {
      writer.uint32(26).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationUserDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationUserDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationUserDetails {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: OrganizationUserDetails): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationUserDetails>): OrganizationUserDetails {
    return OrganizationUserDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationUserDetails>): OrganizationUserDetails {
    const message = createBaseOrganizationUserDetails();
    message.orgId = object.orgId ?? "";
    message.userId = object.userId ?? "";
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseOrganizationUser(): OrganizationUser {
  return { user: undefined, orgDetails: undefined };
}

export const OrganizationUser: MessageFns<OrganizationUser> = {
  encode(message: OrganizationUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    if (message.orgDetails !== undefined) {
      OrganizationUserDetails.encode(message.orgDetails, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgDetails = OrganizationUserDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationUser {
    return {
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      orgDetails: isSet(object.orgDetails)
        ? OrganizationUserDetails.fromJSON(object.orgDetails)
        : isSet(object.org_details)
        ? OrganizationUserDetails.fromJSON(object.org_details)
        : undefined,
    };
  },

  toJSON(message: OrganizationUser): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.orgDetails !== undefined) {
      obj.orgDetails = OrganizationUserDetails.toJSON(message.orgDetails);
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationUser>): OrganizationUser {
    return OrganizationUser.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationUser>): OrganizationUser {
    const message = createBaseOrganizationUser();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.orgDetails = (object.orgDetails !== undefined && object.orgDetails !== null)
      ? OrganizationUserDetails.fromPartial(object.orgDetails)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
